import { render, staticRenderFns } from "./WeeklyOrders.vue?vue&type=template&id=56769227"
import script from "./WeeklyOrders.vue?vue&type=script&lang=js"
export * from "./WeeklyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports